<div class="padding-10 passwordBox">
  <div class="col-md-12">
    <span style="font-size:30px;font-weight:700;color:#333f48;">
      Distributor Portal
    </span>
    </div>
    <div class="col-md-12">
      <span style="font-size:14px;" class="darkblue-label">SIGN INTO YOUR ACCOUNT</span>
    </div>
    <div class="col-md-12 mt-2">
      <input type="text" name="username" class="w-100" placeholder="Username" [(ngModel)]="Username" />
    </div>

    <div class="col-md-12 mt-2">
      <input type="password" name="password" class="w-100" placeholder="Password" [(ngModel)]="Password" (keydown.enter)="btnUserLogin_Click()" />
      <br />
      <div>
        <span style="background-color: transparent; border: none; color: #0062c8;" class="clickable" (click)="ForgotPassword_Click()">Forgot Password</span>
        <!--<button class="primary text-center w-100" style="background-color: transparent; border: none; color: #0062c8;" (click)="ForgotPassword_Click()">Forgot Password</button>-->

      </div>

    </div>
    <div class="col-md-12">
      <p>{{InvalidMessage}}</p>
      <button (click)="btnUserLogin_Click()" (keydown.enter)="btnUserLogin_Click()" class="w-100 primary-button blue">Log in</button>
    </div>
    <div class="col-md-12 mt-2">
      <!--<div class="text-center w-100">
        Or
      </div>
      <div class="text-center w-100 pt-2">
        
        <button (click)="CreateAccount_Click()" class="w-100 primary-button blue">Create account</button>
      </div>-->
      <!--<ng-container *ngIf="isGuestActive">
        <div class="text-center w-100">
          Or
        </div>
        <div class="text-center w-100">-->
      <!--<a href="" class="primary" (click)="CreateAccount_Click()" style="text-decoration:none;">Create account</a>-->
      <!--<input type="button" (click)="ContinueAsGuest()" [ngClass]="{'buttonDisabled':chkAgreeTerms == false}" [disabled]="!chkAgreeTerms" value="Continue as guest" class="w-100 primary-button" />
        </div>
        <div class="w-100 form-group row">
          <div class="form-row">
            <div class="col-md-2">
              <input type="checkbox" id="chkAgreeTerms" name="chkAgreeTerms" [ngModel]="chkAgreeTerms" style="margin:2px;" (ngModelChange)="chkAgreeTerms_Check($event)" class="w-100" />
            </div>
            <div class="col-md-10">
              <label for="chkAgreeTerms" class="col-md-10">I have read and agree to the terms and conditions</label>
            </div>
          </div>
        </div>
      </ng-container>-->
      <div class="pt-3">
        <p>
          <a style="text-decoration: none; color: #0062c8;" class="clickable" (click)="previewTermsAndConditions()"><b>Part of the Tolomatic Sales Channel or an employee?</b></a>
        </p>
      </div>
    </div>
  </div>
  <app-modal [hidden]="true"></app-modal>

  <div #spinnerModal id="spinnerModal" [hidden]="hideLoginLoadingModal" style="width:100%;height:90%;position:absolute;z-index:10000;display:block;top: 80px;;left:0; background-color:#AAAAAA;opacity:0.4;">
    <div style="position:fixed;top:45%;left:45%;">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  </div>
